module.exports = __webpack_public_path__ + "img/ic_shipping_w.38d066da.svg";